import { ReactElement } from 'react';
import { Text, Tabs, HStack, TextProps } from '@chakra-ui/react';
import { TabHeader } from 'types/tab';
import { TabBarVariant } from './TabBar';

type Props = TabHeader & {
  variant?: TabBarVariant;
};

export const CustomTab = ({
  icon,
  tabName,
  num,
  variant = TabBarVariant.ARTICLE,
}: Props): ReactElement => {
  const textAlign = variant === TabBarVariant.SEARCH ? 'left' : 'center';
  const getTextStyle = (tabVariant: TabBarVariant): TextProps['textStyle'] => {
    switch (tabVariant) {
      case TabBarVariant.SEARCH:
        return 'body.xs.regular';
      case TabBarVariant.WORKSHEET:
        return 'body.s.regular';
      default:
        return 'body.m.regular';
    }
  };

  const marginRight = variant === TabBarVariant.SEARCH ? '12px' : '0px';
  const getBorderColor = (tabVariant: TabBarVariant): string => {
    switch (tabVariant) {
      case TabBarVariant.ARTICLE:
      case TabBarVariant.WORKSHEET:
        return 'border.accent.active';
      case TabBarVariant.FAVORITE:
        return 'background.accent';
      default:
        return '';
    }
  };

  const getColor = (tabVariant: TabBarVariant): string => {
    switch (tabVariant) {
      case TabBarVariant.FAVORITE:
        return 'text.primary';
      case TabBarVariant.WORKSHEET:
        return 'text.accent';
      default:
        return getBorderColor(tabVariant);
    }
  };

  const defaultColor = variant === TabBarVariant.WORKSHEET ? 'text.tertiary' : undefined;

  return (
    <Tabs.Trigger
      mr={marginRight}
      position="relative"
      cursor="pointer"
      _selected={{
        color: getColor(variant),
      }}
      _active={{
        color: getColor(variant),
      }}
      color={defaultColor}
      // _focus={{ outline: 'none' }}
      // {...tabProps}
      value={tabName ?? ''}
      pt={variant === TabBarVariant.WORKSHEET ? 'xs' : undefined}
      pb={variant === TabBarVariant.WORKSHEET ? 'xs' : '10px'}
      mb={0}
      flexShrink={0}
      px={variant === TabBarVariant.WORKSHEET ? 'xs' : undefined}
    >
      <HStack align="center" gap={variant === TabBarVariant.WORKSHEET ? '2xs' : '5px'}>
        {icon}
        <Text textStyle={getTextStyle(variant)}>{tabName}</Text>
        {num !== undefined && (
          <Text textStyle={getTextStyle(variant)} ml="2px">
            ({num})
          </Text>
        )}
      </HStack>
    </Tabs.Trigger>
  );
};
